import { WithContext, OfferCatalog } from "schema-dts"

export const planJsonLd: WithContext<OfferCatalog> = {
    "@context": "https://schema.org",
    "@type": "OfferCatalog",
    name: "Our Plans",
    itemListElement: [
        {
            "@type": "Offer",
            name: "Recall Lite",
            price: "0",
            priceCurrency: "USD",
            description: "For connected personal notes",
        },
        {
            "@type": "Offer",
            name: "Recall Plus",
            price: "7",
            priceCurrency: "USD",
            description: "Unlock your second brain",
        },
        {
            "@type": "Offer",
            name: "Recall Business",
            priceCurrency: "USD",
            description: "For collective company intelligence",
        },
    ],
}
